import { createStore, applyMiddleware, Store } from "redux";
import createSagaMiddleware from "redux-saga";

import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";

/**Types State dos modulos */
import { StatusAppState } from "../modulos/root/root.model"
import { MedicoState } from "../modulos/medico/medico.model"
import { SalaState } from "../modulos/sala/sala.model"
import { PacienteState } from "../modulos/paciente/paciente.model"
import { AtendimentoState } from "../modulos/atendimento/atendimento.model"
import { ConfigPainelChamadaState } from "../modulos/configPainelChamada/confpc.model";
import { PainelState } from "../modulos/painel/painel.model";



/**State geral para exibir os types na view */
export interface ApplicationState {
    statusAppState:StatusAppState,
    medicoState:MedicoState,
    salaState:SalaState,
    pacienteState:PacienteState,
    atendimentoState:AtendimentoState,
    configPainelChamadaState:ConfigPainelChamadaState,
    painelState:PainelState


}

const sagaMiddleware = createSagaMiddleware()

const store:Store <ApplicationState> = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export default store;
 